import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Textarea,
  Stack,
  FormLabel
} from '@chakra-ui/react';

const ProjectFormModal = ({ isOpen, onClose, project, onSave }) => {
  const [form, setForm] = useState({
    projectTitle: '',
    parish: '',
    projectDescription: '',
    pastor: '',
    contactName: '',
    contactEmail: '',
    contactPhone: ''
  });

  // Load existing project data when editing
  useEffect(() => {
    if (project) {
      setForm(project);
    }
  }, [project]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    onSave(form);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Project</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Stack spacing={3}>
            <Input
              name="projectTitle"
              value={form.projectTitle || ''}
              onChange={handleChange}
              placeholder="Project Title"
            />
                    <FormLabel>Project Title</FormLabel>
            

            <Input
              name="parish"
              value={form.parish || ''}
              onChange={handleChange}
              placeholder="Parish"
            />
        <FormLabel>Parish/Institution *</FormLabel>

            <Input
              name="pastor"
              value={form.pastor || ''}
              onChange={handleChange}
              placeholder="Pastor / Administrator"
            />
        <FormLabel>Pastor</FormLabel>

            <Input
              name="contactName"
              value={form.contactName || ''}
              onChange={handleChange}
              placeholder="Contact Name"
            />
                    <FormLabel>Contact Name</FormLabel>


            <Input
              name="contactEmail"
              value={form.contactEmail || ''}
              onChange={handleChange}
              placeholder="Contact Email"
            />
        <FormLabel>Contact Email</FormLabel>

            <Input
              name="contactPhone"
              value={form.contactPhone || ''}
              onChange={handleChange}
              placeholder="Contact Phone"
            />
        <FormLabel>Contact Phone</FormLabel>

            <Textarea
              name="projectDescription"
              value={form.projectDescription || ''}
              onChange={handleChange}
              placeholder="Project Description"
            />
                    <FormLabel>Project Description</FormLabel>

          </Stack>
        </ModalBody>

        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>

          <Button colorScheme="blue" onClick={handleSubmit}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ProjectFormModal;